import React, { useState, useEffect } from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RecordNotFoundNoNewNotification from "../../../common/RecordNotFoundNoNewNotification";
import { useNavigate } from "react-router-dom";
import { getAdvisoryDocListService } from "../../../services/ServiceAdvisoryService";
import { useLoading } from "../../../common/LoadingContext";
import { useNotificationContext } from "../../../common/NotificationContext";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
const ServiceAdv = (props) => {
  const {
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
    handleMoveToReadFunc
  } = props;
  const [brodcastList, setBrodcastList] = useState([]);
  const [ids, setIds] = useState([]);
  const [prevLocalIds, setPrevLocalIds] = useState([]);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();

  useEffect(() => {
    setBrodcastList(notificationRecords);
  }, [
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
  ]);

  const navigate = useNavigate();

  useEffect(() => {
    var localFields = JSON.parse(localStorage.getItem("NotifyserviceAdv"));
    if (localFields) {
      setIds(localFields);
    }
  }, []);

  const handleClickTitle = (id) => {
    var localFields = JSON.parse(localStorage.getItem("NotifyserviceAdv"));

    setPrevLocalIds(localFields);
    if ((ids.indexOf(id) || localFields?.includes(id)) !== -1) {
    } else {
      ids.push(id);
      localStorage.setItem("NotifyserviceAdv", JSON.stringify(ids));
    }
  };
  const viewAdvisoryList = async (value) => {
    try {
      setLoading(true);
      var requestBody = [];
      requestBody.push(value);
      const response = await getAdvisoryDocListService(requestBody);
      if (response.statusCode === 6) {
        navigate(`/service-advisory-view`, {
          state: { content: response, isUnRead: true, sorting: true,pageNo: page,
            typeId: 1,isFromRead : false },
        });
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to service doc list");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {brodcastList && brodcastList.length > 0 ? (
        brodcastList
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <Accordion
                className={
                  localStorage.getItem("NotifyserviceAdv")?.includes(row.id) ||
                  prevLocalIds?.includes(row.id)
                    ? "checkedNotification"
                    : ""
                }
                sx={{
                  borderLeft: 7,
                  p: 0,
                  borderColor: "#003f93",
                  mb: 1,
                  textAlign: "left",
                }}
                key={row.id}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  onClick={() => {
                    handleClickTitle(row.id);
                    handleMoveToReadFunc('1',row.id)
                  }}
                  className="notification_title"
                >
                  <Typography sx={{textTransform:"capitalize"}}>{row.title} </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>{row.content}</Typography>
                  <Typography sx={{ textAlign: "right" }}>
                    <ArrowRightAltIcon
                      fontSize="large"
                      sx={{ color: "#003f93", cursor: "pointer" }}
                      onClick={() => viewAdvisoryList(row.notificationTypeId)}
                    />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })
      ) : (
        <RecordNotFoundNoNewNotification />
      )}
    </>
  );
};

export default ServiceAdv;
